"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function useCounter(initialValue = 0) {
    const [count, setCount] = react_1.useState(initialValue);
    const incrementKeySuffix = react_1.useCallback(() => setCount(prev => prev + 1), []);
    return [count, incrementKeySuffix];
}
exports.default = useCounter;
